import { defineChain } from 'viem'

export default defineChain({
	id: 88882,
	name: 'Chiliz Chain Spicy',
	network: 'chiliz-chain-spicy',
	rpcUrls: {
		default: {
			http: ['https://spicy-rpc.chiliz.com']
		}
	},
	blockExplorers: {
		default: {
			name: 'Chiliz Spicy Explorer',
			url: 'https://testnet.chiliscan.com/'
		}
	},
	nativeCurrency: {
		name: 'Chiliz',
		symbol: 'CHZ',
		decimals: 18
	},
	testnet: true,
	maxSupply: 8888888888000000
})
